import { useEffect, useRef } from 'react'

const COLUMNS = [
  { key: 'description', label: 'Description' },
  { key: 'type', label: 'Type' },
  { key: 'priority', label: 'Priority' },
  { key: 'status', label: 'Status' },
  { key: 'assignee', label: 'Assignee' },
  { key: 'evidence', label: 'Evidence' },
]

interface ColumnVisibilityToggleProps {
  visibleColumns: Record<string, boolean>
  onToggle: (column: string) => void
  onClose: () => void
}

export function ColumnVisibilityToggle({ visibleColumns, onToggle, onClose }: ColumnVisibilityToggleProps) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClose()
      }
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [onClose])

  return (
    <div
      ref={ref}
      className="absolute right-0 top-full mt-1 z-50 py-2 rounded-lg min-w-[180px]"
      style={{
        background: 'var(--color-surface)',
        border: '1px solid var(--color-border)',
        boxShadow: 'var(--shadow-md)',
      }}
    >
      {COLUMNS.map(col => {
        const isOn = visibleColumns[col.key] !== false
        return (
          <button
            key={col.key}
            className="flex items-center gap-2 w-full px-3.5 py-1.5 text-[13px] hover:bg-[var(--color-warm-50)]"
            style={{ color: 'var(--color-text-secondary)' }}
            onClick={() => onToggle(col.key)}
          >
            <div
              className="flex items-center justify-center"
              style={{
                width: 14,
                height: 14,
                border: `1.5px solid ${isOn ? 'var(--color-accent)' : 'var(--color-warm-400)'}`,
                borderRadius: 3,
                background: isOn ? 'var(--color-accent)' : 'transparent',
              }}
            >
              {isOn && (
                <svg width="8" height="6" viewBox="0 0 8 6" fill="none">
                  <path d="M1 3L3 5L7 1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              )}
            </div>
            {col.label}
          </button>
        )
      })}
    </div>
  )
}
